/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

/**
 * Demo Mode toggle — appears top-right of each Workflow page.
 *
 * Slice 2 baseline: minimal pill button that flips the localStorage
 * flag and broadcasts the change so consumers can re-render.
 * Slice 4 polish: persona display names, watermark, larger fonts.
 */

import React, { useEffect, useState } from 'react';
import { isDemoMode, subscribeDemoMode, toggleDemoMode } from '../../utils/demoMode';

export default function DemoModeToggle() {
  const [enabled, setEnabled] = useState(isDemoMode());

  useEffect(() => subscribeDemoMode(setEnabled), []);

  const onClick = () => {
    setEnabled(toggleDemoMode());
  };

  return (
    <button
      type="button"
      className={`wf-demo-toggle ${enabled ? 'is-on' : ''}`}
      onClick={onClick}
      title="Hides internal IDs, latency, and LLM tier — for clean video capture"
      aria-pressed={enabled}
    >
      <span className="wf-demo-toggle-dot" aria-hidden="true" />
      Demo Mode {enabled ? 'ON' : 'OFF'}
    </button>
  );
}
